<template lang="pug"> 
  n-dialog(
    v-model='dialog'
    max-width='60%'
    max-height='40%'
  )
    v-card.px-3(
      dark color='var(--bg-main-color)'
    )
      v-row(no-gutters)
        v-col(cols='12', align='center')
          br
          h2 {{ `ยินดีด้วย` }}

          h4(v-if="item && item.is_need_unlock") {{ $t('you-unlock-promotion') }}
          h4(v-else) {{ $t('you-received') }} {{ `${this.amount} เครดิต` }}
        v-col(cols='12').d-flex.justify-center
          n-card-voucher(
            :item='item'
            @click='dialog=false'
          )

</template>
<script>   
const DEFAULT = () => ({
    dialog: false,
    item : null,
    loading : false,
    amount: '0'

})
export default { 
  data: () => DEFAULT(), 
  computed:{
    codeError () {
      return null
    }
  },
  watch: {
    dialog () {
      if(!this.dialog) {
        window.location.reload()
      } 
    }
  },
  methods : { 
    async open (item) {  
      this.reset()
      this.item=item
      this.amount = item.amount
      this.dialog = true
    }, 
    
    reset () {
      Object.assign(this.$data, DEFAULT())
    },

    close () {
      this.dialog = false
    }, 
  }
}
</script>